import React from 'react';
import { Box, Typography } from '@mui/material';
import AdminCategoryManager from '../../admin/CategoryManager';

/**
 * Category Manager component for managers
 * This is a wrapper around the admin CategoryManager component
 * but placed within the audit section for managers
 */
const ManagerCategoryManager = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Category Management
      </Typography>
      <Typography variant="body1" paragraph>
        Create and manage categories to organize questions for questionnaires.
      </Typography>
      
      {/* Use the existing CategoryManager component */}
      <AdminCategoryManager />
    </Box>
  );
};

export default ManagerCategoryManager;
